<template>
  <div class="flexX_center">
    <div class="services flexY_start" style="margin-bottom: 200px">
      <div class="image flexY_start">
        <div style="margin-top: 150px">
          <div style="color: #ffffff; font-size: 54px; word-wrap: break-word">
            服务介绍
          </div>
          <br />
          <div
            style="
              font-size: 18px;
              color: #ffffff;
              letter-spacing: 3px;
              line-height: 1.75;
              margin-top: 40px;
            "
          >
            礼邦物流 提供快速且优质的货品运输报关服务
          </div>
        </div>
      </div>
      <div class="flexY_center" style="margin: 60px 0">
        <div
          class="OUR_SERVICE"
          style="font-size: 60px; color: #ebebf3; font-weight: 700"
        >
          OUR SERVICE
        </div>
        <div
          class="wmdfw"
          style="
            font-size: 40px;
            color: #000000;
            font-weight: 600;
            margin-top: -40px;
          "
        >
          我们的服务
        </div>
        <div
          style="
            background-color: rgb(19, 100, 233);
            height: 7px;
            width: 80px;
            margin-top: 30px;
          "
        ></div>
      </div>
      <div class="serviceItems-1" style="width: 100%">
        <div
          class="serviceItem dingcang"
          style="background-color: rgb(159, 196, 242)"
        >
          <div class="txt1">
            <img src="../assets/services/-47768.png" />
          </div>
          <div class="txt2">订舱</div>
          <div class="txt3">
            公司秉承以人为本、追求超越的经营理念
            恪守诚信为本、客户至尊为服务宗旨
          </div>
        </div>
        <div class="serviceItem" style="background-color: rgb(128, 178, 238)">
          <div class="txt1">
            <img src="../assets/services/27449444.png" />
          </div>
          <div class="txt2">报关</div>
          <div class="txt3">我们提供快速报关功能，一体化服务</div>
        </div>
        <div
          class="serviceItem yunshu"
          style="background-color: rgb(96, 158, 233)"
        >
          <div class="txt1">
            <img src="../assets/services/27588180.png" />
          </div>
          <div class="txt2">运输</div>
          <div class="txt3">
            我们提供7x24小时的全天候响应速度 随时随地为您服务
          </div>
        </div>
      </div>
      <div class="serviceItems-2" style="width: 100%; margin-top: 5px">
        <div
          class="serviceItem cangchu"
          style="background-color: rgb(159, 196, 242)"
        >
          <div class="txt1">
            <img src="../assets/services/27588498.png" />
          </div>
          <div class="txt2">仓储</div>
          <div class="txt3">我们提供优质的储存服务，保障货物存取无忧</div>
        </div>
        <div
          class="serviceItem duichang"
          style="background-color: rgb(128, 178, 238)"
        >
          <div class="txt1">
            <img src="../assets/services/27445621.png" />
          </div>
          <div class="txt2">堆场</div>
          <div class="txt3">
            通过坚持不懈地开拓创新、与时俱进 公司不断开创新局面、实现新跨越
          </div>
        </div>
      </div>
      <div class="serviceItems-3" style="width: 100%; margin-top: 5px">
        <div class="serviceItem" style="background-color: rgb(249, 250, 252)">
          <div class="txt1 flexX_center">
            <i class="reppon-icon icon-hezi iconStyle" />
          </div>
          <div class="txt2" style="font-weight: 500">线上下单</div>
          <div class="txt3">线上下单，快速便捷</div>
        </div>
        <div class="serviceItem" style="background-color: rgb(249, 250, 252)">
          <div class="txt1 flexX_center">
            <i class="reppon-icon icon-wode-gengduodingdan iconStyle" />
          </div>
          <div class="txt2">查询订单</div>
          <div class="txt3">订单状态随时可查随时</div>
        </div>
        <div class="serviceItem" style="background-color: rgb(249, 250, 252)">
          <div class="txt1 flexX_center">
            <i class="reppon-icon icon-huoche iconStyle" />
          </div>
          <div class="txt2">预估送达时间</div>
          <div class="txt3">提前预估运输时长，合理规划运输计划</div>
        </div>
        <div class="serviceItem" style="background-color: rgb(249, 250, 252)">
          <div class="txt1 flexX_center">
            <i class="reppon-icon icon-jiesuan iconStyle" />
          </div>
          <div class="txt2">费用结算</div>
          <div class="txt3">费用自动结算，可线上快速对账</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { nextTick } from "vue";

document.addEventListener("scroll", function () {
  const slideInDiv = document.querySelector(".dingcang");
  if (slideInDiv) {
    const divPosition = slideInDiv.getBoundingClientRect().top;
    const screenPosition = window.innerHeight;

    if (divPosition < screenPosition) {
      slideInDiv.classList.add("active");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".yunshu");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("active");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".cangchu");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("active");
    }
  }
});
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".duichang");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("active");
    }
  }
});
nextTick(() => {
  const OUR_SERVICEInDiv = document.querySelector(".OUR_SERVICE");
  const wmdfwInDiv = document.querySelector(".wmdfw");
  setTimeout(() => {
    if (OUR_SERVICEInDiv) {
      OUR_SERVICEInDiv.classList.add("hide");
    }
    if (wmdfwInDiv) {
      wmdfwInDiv.classList.add("hide");
    }
  }, 500);
});
</script>
<style scoped>
.wmdfw {
  transform: scale(0); /* 初始状态：缩小到 0 */
  transition: transform 1.5s ease-out; /* 过渡效果：0.5秒缩放 */
}
.wmdfw.hide {
  transform: scale(1);
}
.OUR_SERVICE {
  transform: scale(0); /* 初始状态：缩小到 0 */
  transition: transform 0.5s ease-out; /* 过渡效果：0.5秒缩放 */
}
.OUR_SERVICE.hide {
  transform: scale(1);
}
.duichang {
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.5s ease-out, opacity 1s ease-out;
}
.duichang.active {
  transform: translateX(0);
  opacity: 1;
}
.cangchu {
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.5s ease-out, opacity 1s ease-out;
}
.cangchu.active {
  transform: translateX(0);
  opacity: 1;
}
.dingcang {
  transform: translateX(-100%);
  opacity: 0;
  transition: transform 0.5s ease-out, opacity 1s ease-out;
}
.dingcang.active {
  transform: translateX(0);
  opacity: 1;
}
.yunshu {
  transform: translateX(100%);
  opacity: 0;
  transition: transform 0.5s ease-out, opacity 1s ease-out;
}
.yunshu.active {
  transform: translateX(0);
  opacity: 1;
}
.services {
  width: 77%;
}
.image {
  background-image: url("../assets/services/27442727.png");
  background-size: cover; /* 确保图片覆盖整个元素 */
  background-position: center; /* 将图片居中显示 */
  width: 100%;
  height: 667px;
}
.serviceItems-1 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0px;
}
.serviceItems-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
}
.serviceItems-3 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.serviceItems-3 .serviceItem .txt1 {
  width: 60px;
  height: 60px;
}
.serviceItems-3 .serviceItem .txt2 {
  color: #000000;
  font-size: 25px;
  line-height: 2;
  margin-top: 20px;
}
.serviceItems-3 .serviceItem .txt3 {
  color: #bdbdbd;
  font-size: 12px;
}
.serviceItems-3 .serviceItem {
  padding: 70px;
}
.iconStyle {
  font-size: 50px;
}
.iconStyle:hover {
  font-size: 60px;
}
.serviceItem {
  padding: 90px;
}
.serviceItem .txt1 img {
  width: 50px;
}
.serviceItem .txt2 {
  font-size: 30px;
  color: #ffffff;
  line-height: 4;
}
.serviceItem .txt3 {
  font-size: 15px;
  color: #ffffff;
  line-height: 1.5;
}
</style>
